export default __webpack_public_path__ + "static/media/photo--sm--123.5e5f30d0.jpg";